import styled from 'styled-components';

export const Container = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
`;

export const FormCharRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: stretch;
    width: 100%;
`;

export const CharAvatar = styled.div`
    width: 93px;
    height: 93px;
    margin-right: 10px;
    background: #111 url('${()=>window.basedir}/images/token_placeholder.png') no-repeat 50% 50%;
    background-size: contain;
    cursor: pointer;
    border: 1px solid #555;
    position: relative;
`;

export const CharAvatarImage = styled.img`
    width: 93px;
    height: 93px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
`;


export const FormCharColor = styled.div`
    width: 100%;
    height: 30px;
    background-color: ${props => props.color};
    margin-bottom: 10px;
`;

export const FormCharStack = styled.div.attrs(props => ({
    style: props.width ? {
        flex: 0,
        width: props.width,
        minWidth: props.width
    } : {}
}))`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    flex: 1;

    &:not(:first-child) {
        margin-left: 10px;
    }

    &.big {
        flex: 3;
    }

    &.wide {
        flex: 2;
    }

    &.small {
        flex: 0;
        width: 10px;
    }

    &.vcenter {
        justify-content: center;
    }
`;

export const FormCharLabel = styled.div.attrs((props)=>({
    style: props.height ? {
        height: props.height
    } : {}
}))`
    color: #999;
    font-size: 12px;
    text-transform: uppercase;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    &.big {
        font-size: 14px;
    }

    &.full {
        flex: 1;
    }
`;

export const ViewTabList = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    margin-bottom: 10px;
    border-bottom: 1px solid #444;
`;

export const ViewTab = styled.div`
    border: 1px solid #333;
    padding: 5px 10px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    background-color: #333;
    color: #999;
    margin-right: 1px;
    font-size: 12px;
    position: relative;
    z-index: 1;

    &.active {
        z-index: 3;
        color: #fff;
        background-color: #444;
        border: 1px solid #444;
    }
`;

export const ViewContent = styled.div`
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: stretch;
`;

export const ButtonBar = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    justify-content: stretch;
`;

export const FormCharEmptyLabel = styled.div`
    content: ' ';
    font-size: 12px;
    height: 12px;
    width: 10px;
`;

export const FormCharInput = styled.input`
    border: 1px solid #555;
    background-color: #111;
    height: 30px;
    padding: 0 5px;
    width: 100%;
    margin-bottom: 10px;
    color: #999;

    &.fullWidth {
        width: 100%;
    }

    &.withMargin {
        margin-right: 10px;
    }
`;

export const FormCharSelect = styled.select`
    border: 1px solid #555;
    background-color: #111;
    height: 30px;
    padding: 0 5px;
    width: 100%;
    margin-bottom: 10px;
    color: #999;

    &.fullWidth {
        width: 100%;
    }
`;

export const Warning = styled.div`
    color: #999;
    font-size: 12px;
    text-transform: uppercase;
    width: 100%;
    height: 30px;
    background-color: #500;
    border: 1px solid #900;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export const TextArea = styled.textarea`
    color: #aaa;
    font-size: 14px;
    width: 100%;
    flex: 1;
    resize: none;
    background-color: #111;
    border: 1px solid #333;
    padding: 5px;
    margin: 5px 0;
`;

export const CopyInput = styled.input`
    border: 1px solid #555;
    background-color: #111;
    width: 30px;
    height: 30px;
    min-width: 30px;
    min-height: 30px;
    padding: 0 5px;
    margin: 5px 10px 10px 0;
    color: #999;
`;